import React from "react";
import RootStore from "./stores/rootStore";

export default React.createContext(new RootStore());
